export default __webpack_public_path__ + "static/media/liondesk.b01897ae.png";